import "./ProductPage.css"
import React, {useCallback, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom';
import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import {PrevButton, NextButton, usePrevNextButtons} from './EmblaCarouselArrowButtons'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import {SyncLoader} from "react-spinners";

export default function ProductPage(props) {

    const id = useParams().id;
    const [images, setImages] = useState();
    const [product, setProduct] = useState();
    const [selectedVariant, setSelectedVariant] = useState(0);
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay()])

    useEffect(() => {
        fetch("/backend/database.json", { cache: "no-store" })
            .then(response => {
                return response.json()
            })
            .then(data => {
                let prodInfo = null;
                Object.values(data).forEach(subArray => {
                    if (Array.isArray(subArray)) {
                        const prodotto = subArray.find(prod => prod.id === id);
                        if (prodotto) {
                            prodInfo = prodotto;
                        }
                    }
                });
                setProduct(prodInfo);
            })
    }, [id]);

    useEffect(() => {
        if(product){
            const fetchImages = async () => {
                let variant;
                if(product.variants)
                    variant = product.variants[selectedVariant]; // Seleziona la variante
                else
                    variant = product;

                const imageUrls = [];
                let i = 1;

                while (true) {
                    try {
                        const response = await fetch(`/backend/${variant.imageFolder}/${i}.jpg`, { cache: "no-cache" });
                        if (!response.ok) break; // Esci dal ciclo se la risposta non è OK

                        const blob = await response.blob();
                        const imageUrl = URL.createObjectURL(blob);
                        imageUrls.push({ imageUrl, key: i });
                        i++;
                    } catch (error) {
                        console.error("Errore nel recupero dell'immagine:", error);
                        break;
                    }
                }
                if(imageUrls.length > 0) {
                    setImages(imageUrls);
                }
                else {
                    const response = await fetch(`/backend/databaseImage/NoImage.jpg`, { cache: "no-cache" });
                    const blob = await response.blob();
                    const imageUrl = URL.createObjectURL(blob);
                    imageUrls.push({ imageUrl, key: i });
                    setImages(imageUrls)
                }
            };
            fetchImages();
        }
    }, [product, selectedVariant]);

    const onNavButtonClick = useCallback((emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const resetOrStop =
            autoplay.options.stopOnInteraction === false
                ? autoplay.reset
                : autoplay.stop

        resetOrStop()
    }, [])

    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
        emblaApi,
        onNavButtonClick
    )

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi, onNavButtonClick)

    return (
        <>
            {
                product ?
                    <div id="productPage">
                        <section className="embla">
                                <div className="embla__viewport" ref={emblaRef}>
                                    <div className="embla__container">
                                        {images ? images.map(image => (
                                                <div className="embla__slide" key={image.key}>
                                                    <div className="embla__slide__number">
                                                        <img id="ProductVariantImage" src={image.imageUrl}
                                                             alt="FotoProdotto"/>
                                                    </div>
                                                </div>
                                            )) :
                                            <div id="loaderContainer">
                                                <SyncLoader
                                                    className="dotLoader"
                                                    color="#ffffff"
                                                    size={12}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            <div className="embla__controls">
                                <div className="embla__buttons">
                                    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled}/>
                                    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled}/>
                                </div>

                                <div className="embla__dots">
                                    {scrollSnaps.map((_, index) => (
                                        <DotButton
                                            key={index}
                                            onClick={() => onDotButtonClick(index)}
                                            className={'embla__dot'.concat(
                                                index === selectedIndex ? ' embla__dot--selected' : ''
                                            )}
                                        />
                                    ))}
                                </div>
                            </div>
                        </section>
                        <div id="productInfo">
                            <div id="productName">
                                {product.name}
                            </div>
                            {product.weight &&
                                <div>
                                    <span className="bold"> Peso:</span> {product.weight}
                                </div>
                            }
                            {product.pz &&
                                <div>
                                    <span className="bold"> Quantità:</span> {product.pz} pz
                                </div>
                            }
                            {product.podPrice &&
                                <div>
                                    <span className="bold"> Prezzo unitario:</span> {product.podPrice} €
                                </div>
                            }
                            <div>
                                <span className="bold"> Descrizione:</span> {product.description}
                            </div>
                            {product.variants &&
                                <div id="colorButtonContainer">
                                    <span className="bold"> Colori:</span>
                                    {product.variants.map((variant, index) => {
                                        return (
                                            <button
                                                key={index}
                                                onClick={() => setSelectedVariant(index)}
                                                id="colorButton"
                                                style={{
                                                    backgroundColor: variant.colorHex,
                                                    borderColor: product.variants[selectedVariant].colorHex === variant.colorHex ? "#321817" : "transparent",
                                                    boxShadow: product.variants[selectedVariant].colorHex === variant.colorHex ? "0 0 0 2px #fff" : "none",
                                                }}
                                            />
                                        );
                                    })}
                                </div>
                            }
                        </div>
                    </div> :
                    <SyncLoader
                        className="dotLoader"
                        color="#ffffff"
                        size={12}
                    />
            }
        </>
    )
}